__turbopack_context__.v({
  "card": "PriceSetupCard-module-scss-module__JHvbBW__card",
  "categories": "PriceSetupCard-module-scss-module__JHvbBW__categories",
  "category": "PriceSetupCard-module-scss-module__JHvbBW__category",
  "countries": "PriceSetupCard-module-scss-module__JHvbBW__countries",
  "edit-btn": "PriceSetupCard-module-scss-module__JHvbBW__edit-btn",
  "products": "PriceSetupCard-module-scss-module__JHvbBW__products",
});
